export function lerp(arg0: number, arg1: number, delta: number): number {
    return arg0 + delta * (arg1 - arg0);
}
